import { FC } from "react";
import { useTranslation } from "react-i18next";
import { MobileSearch } from "src/Modules/Hotels/Components";

interface HotelSearchMobileProps {
  imgUrl?: string;
}

const HotelSearchMobile: FC<HotelSearchMobileProps> = ({ imgUrl }) => {
  const { t } = useTranslation();
  return (
    <div className="flex w-full flex-col items-center justify-center bg-background-minimal pb-2">
      <div className="relative w-full">
        <div
          className="relative h-[260px] w-full overflow-hidden bg-cover bg-no-repeat shadow-inner"
          style={{ backgroundImage: `url(${imgUrl})`}}
        >
          <div className="absolute inset-0 bg-black/50" />
          <div className="relative z-10 flex h-full flex-col justify-center gap-1.5 px-5 pb-16">
            <h1 className="text-start text-xl font-bold leading-tight text-white drop-shadow-sm">
              {t("Hotels.search.heroTitle")}
            </h1>
            <p className="text-start text-sm text-white/90 drop-shadow-sm">{t("Hotels.search.heroSubtitle")}</p>
          </div>
        </div>

        <div className="relative z-20 -mt-20 h-full">
          <MobileSearch />
        </div>
      </div>
    </div>
  );
};

export default HotelSearchMobile;

